<!-- eslint-disable -->
<template lang="pug">
    .play-box
        template(v-if='!isLoading')
            game-header(
                v-show='!gameFinished && gameStarted'
                :time='getTime'
                :slug="type"
                :gameType="parameters && parameters.courseType"
                @soundStateChanged ="headerKey = !headerKey"
                :key="headerKey"
                :is-homework="!!exerciseId"
            )
            game-preparation-counter(v-if='!gameStarted && isGameTuned' :counter="counter")
            template(v-else)
                .shutter__container
                    .shutter__container_body
                        .shutter__container_interactive-place(v-if='gameStarted && !gameFinished || !isGameTuned')
                            .shutter__container_interactive-place_header(v-if='isGameTuned')
                                | {{ $i18n.t('trainer.trainer_game_shutter_readWords') }}
                            scaling-bar(
                                v-if="!isGameTuned"
                                @doneWithPreparing='doneWithPreparing'
                                @setFontSize='setFontSize'
                                :is-text-mode="isTextMode"
                                :amount-of-words-in-row="parameters.amountOfWordsInRow"
                                :amount-of-words-in-column="parameters.amountOfItemsInColumn"
                                :font-size='fontSize'
                                rows-name='shutter__container_interactive-place_main-box_row'
                            )
                            template(v-else)
                                .shutter__container_buttons(v-if='showSlowDownButton')
                                    cs-button(pattern='primary-outline' @click='slowDownGame')
                                        | {{ $i18n.t('trainer.trainer_game_noTime') }}
                                .shutter__container_interactive-place_text-label(v-if='parameters.textLabel')
                                    | {{ textLabel }}
                                .shutter__container_interactive-place_main-box(
                                    @wheel='isTextMode && handleScroll($event)'
                                    @mousedown='handleMouseDown($event)'
                                    @mouseleave='isDown = false'
                                    @mouseup='isDown = false'
                                    @mousemove='handleMouseMove($event)'
                                    :style="stylesTextBox"
                                )
                                    .shutter__container_interactive-place_main-box_body(:class="{'shutter__text': isTextMode}")
                                        transition-group(
                                            tag="div",
                                            name="fade",
                                            class="lines-container",
                                            :move-class="moveTransitionClass",
                                        )
                                            .shutter__container_interactive-place_main-box_row(
                                                v-for='(word, index) in filteredDisplayedLines',
                                                :key="(index + hiddenLinesCounter) + word",
                                            )
                                                span.shutter__words(
                                                    v-html="word",
                                                )
                                        .shutter__container_interactive-place_main-box_shutter-container
                                            .wave
                        .end-game-container(v-else-if='gameFinished')
                            fireworks
                            .shutter__container_result-container
                                result-image.shutter__container_result-image(status="success")
                                result-buttons(
                                    :exercise-id="exerciseId"
                                    :games-type="currentGamesType"
                                    show-restart-button
                                    @restartGame="restartGame"
                                )
                                    slot
        cs-loader(v-else)
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash'
    import ScalingBar from './ScalingBar.vue';
    import ShutterRussianLanguage from '../../../../api/games/shutterRussianLanguage';
    import textScrollMixin from '../../../../utils/trainer/textScroll';
    import playBoxGameMixin from '../../../../utils/trainer/playBoxGameMixin.js';
    import IntervalConfig from "../../configs/IntervalConfig";
    import metronome from '../../../../utils/trainer/metronome.js';
    import GamePreparationCounter from "../../GamePreparationCounter.vue";
    import GameInfo from "../GameInfo.vue";
    import RotationIcon from "../../../../svg/RotationIcon.vue";

    const MIN_TIME = 0.1;
    const DEFAULT_VOLUME = 0.6;
    const SECONDS_IN_MINUTE = 60;
    const SAME_UNICODE_SYMBOLS = ['Е', 'Ё'];

    function DEFAULT_DATA () {
        return {
            words: [],
            shutterTimeout: null,
            displayedLines: [],
            shutterInterval: null,
            timeSubtrahend: 0,
            fontSize: 0,
            hiddenLinesCounter: 0,
            isGameTuned: false,
            counterTimer: null,
            minTime: 0.1,
        }
    }

    export default {
        mixins: [textScrollMixin, playBoxGameMixin, metronome],
        beforeDestroy () {
            this.gameStarted = false;
            if (this.shutterTimeout) {
                clearTimeout(this.shutterTimeout);
            }
            if (this.shutterInterval) {
                clearTimeout(this.shutterInterval);
            }
            if (this.counterTimer) {
                clearTimeout(this.counterTimer);
            }
        },
        data () {
            return Object.assign({
                availableSpeed: IntervalConfig.secondsForShutter,
            }, DEFAULT_DATA())
        },
        mounted() {
            this.fontSize = this.isTextMode ? 14 : 25;
        },
        computed: {
            isTextMode () {
                return this.parameters && this.parameters.mode === 'text';
            },
            textLabel () {
                if (this.parameters.textLabel) {
                    return this.parameters.textLabel.replace(/\([^)]+\)/, '')
                }
                return "";
            },
            currentGamesType () {
                return this.type === 'ShutterOnline' ? 'onlineSchool' : 'fastReading';
            },
            stylesTextBox () {
                const result = {
                    'font-size': `${this.fontSize}px`
                }; 
                let minusHeight = null;
                if(this.windowWidth >= 992) {
                    if(this.showSlowDownButton) {
                        minusHeight = 340;
                    } else {
                        minusHeight = 305;
                    }
                }
                if(minusHeight !== null) {
                    result.height = `calc(100vh - ${minusHeight}px)`;
                }
                return result;
            },
            moveTransitionClass () {
                if (this.parameters.shutterSpeed.showTime >= 0.5 && this.parameters.shutterSpeed.showTime < 0.7) {
                    return 'fade-move-45';
                }
                if (this.parameters.shutterSpeed.showTime >= 0.3 && this.parameters.shutterSpeed.showTime < 0.5) {
                    return 'fade-move-25';
                }
                if (this.parameters.shutterSpeed.showTime > 0.1 && this.parameters.shutterSpeed.showTime < 0.3) {
                    return 'fade-move-1';
                }
                if (this.parameters.shutterSpeed.showTime === 0.1) {
                    return '';
                }
                return 'fade-move';
            },
            filteredDisplayedLines() {
                return this.displayedLines.slice(this.hiddenLinesCounter);
            },
            showSlowDownButton() {
                return this.parameters && this.parameters.shutterSpeed.showTime !== this.availableSpeed[this.availableSpeed.length - 1];
            },
        },
        methods: {
            fetchData() {
                this.getExercise()
                .then(() => {
                    if (!this.isTextMode) {
                        let params = {
                            locale: this.user.locale,
                            type: this.parameters.mode === 'wordColumn' ? 'words' : 'syllables',
                            groups: this.parameters.selectedGroups,
                            groupsLetters: this.parameters.lettersForGroups,
                            wordConstitutingLetters: this.parameters.wordConstitutingLetters
                        }
                        if (this.parameters.locale) {
                            params.locale = this.parameters.locale;
                        }
                      ShutterRussianLanguage.getItems(params).then(data => {
                            this.words = _.map(data, item => this.parameters.mode === 'wordColumn' ? item.word : item.syllable);
                            if (this.parameters.lettersForGroups) {
                                const containsSameUnicodeSymbols = this.parameters.lettersForGroups.some(group => {
                                    return group.letters.some(letter => SAME_UNICODE_SYMBOLS.includes(letter));
                                });
                                if (containsSameUnicodeSymbols) {
                                    const lettersFromGroups = this.parameters.lettersForGroups.reduce((acc, item) => {
                                        return [...acc, ...item.letters];
                                    }, []).map(letter => letter.toUpperCase());
                                    this.words = this.words.filter(item => {
                                        return item.split('').every(letter => {
                                            return lettersFromGroups.includes(letter);
                                        })
                                    })
                                }
                                if (this.parameters.mode === 'wordColumn' && this.words.length < this.parameters.amountOfItemsInColumn) {
                                    this.$toasted.info(
                                        this.$i18n.t('trainer.trainer_insufficientNumberOfWords'),
                                        { duration: 4500 }
                                    )
                                }
                                do {
                                    let arr = this.words;
                                    arr.forEach(item => {
                                        this.words.push(item);
                                    });
                                } while (this.words.length < this.parameters.amountOfItemsInColumn);
                            }
                            !this.parameters.accentedWords &&
                            (this.words = this.words.map(word => word.replace("&#x301;", "")));
                            this.displayedLines = _.take(_.shuffle(_.cloneDeep(this.words)), this.parameters.amountOfItemsInColumn);
                        });
                    } else {
                        this.initLinesFromText();
                    }
                    if (this.parameters.shutterSpeedIncrease) {
                        this.calculateSpeedIncrease();
                    }
                    this.isLoading = false;
                })
                .catch(e => {
                    this.isLoading = false;
                    this.$toasted.error(this.$root.$t('errors.getting_level'));
                    this.$router.push({ name: 'dashboard' });
                })
            },
            slowDownGame () {
                this.gameStarted = false;
                this.hiddenLinesCounter = 0;
                this.stopMetronome();
                if (this.shutterTimeout) {
                    clearTimeout(this.shutterTimeout);
                }
                if (this.shutterInterval) {
                    clearInterval(this.shutterInterval);
                }
                if (this.timer) {
                    this.stopTimer();
                    this.timer = null;
                }
                if (!this.isTextMode) {
                    this.displayedLines = _.shuffle(this.displayedLines);
                }
                let oldSpeedIndex = this.availableSpeed.indexOf(this.parameters.shutterSpeed.showTime);
                let newSpeedIndex = this.availableSpeed.length - oldSpeedIndex > 2 ? oldSpeedIndex + 2 : this.availableSpeed.length - 1;
                this.parameters.shutterSpeed.showTime = this.availableSpeed[newSpeedIndex];
                let words = this.parameters.mode !== 'text' ? 1 : this.parameters.amountOfWordsInRow;
                this.parameters.shutterSpeed.value = Math.round((words / this.parameters.shutterSpeed.showTime) * SECONDS_IN_MINUTE);
                this.counter = 0;
                this.runCounter();
            },
            refreshGameStatBeforeSend () {
                this.gameStat.chainOfAttempts = [];
                this.gameStat.percent = this.exerciseId ? 100 : 0;
                this.gameStat.answers = 0;
                this.gameStat.isCompleted = this.gameFinished;
                this.gameStat.executionTime = this.time;
                this.gameStat.isCorrect = true;
                this.gameStat.parameters = _.cloneDeep(this.parameters);
            },
            initLinesFromText () {
                this.displayedLines = _.chunk(this.parameters.sourceText.split(" "), this.parameters.amountOfWordsInRow).map(arr => arr.join(' '));
            },
            calculateSpeedIncrease () {
                let amountOfLines = this.parameters.mode !== 'text'
                        ? this.parameters.amountOfItemsInColumn
                        : this.displayedLines.length;
                this.minTime = this.parameters.shutterMaxSpeed.showTime ? this.parameters.shutterMaxSpeed.showTime : MIN_TIME;
                this.timeSubtrahend = (this.parameters.shutterSpeed.showTime - this.minTime) / amountOfLines;
            },
            beforeStart () {
                this.startMetronome();
                this.startGame();
            },
            moveDisplayedLines (speed) {
                if (this.gameStarted) {
                    if (this.displayedLines.length - 1 === this.hiddenLinesCounter) {
                        this.finishGame();
                        return;
                    }
                    if (this.parameters.shutterSpeedIncrease && this.parameters.shutterSpeed.showTime !== this.minTime && parseFloat(speed.toFixed(1)) >= this.minTime) {
                        speed -= this.timeSubtrahend;
                    }
                    this.hiddenLinesCounter += 1;
                    this.shutterTimeout = setTimeout(this.moveDisplayedLines, speed * 1000, speed);
                }
            },
            startGame () {
                this.gameStarted = true;
                this.$nextTick(() => {
                    window.scrollTo(0, 0);
                });
                this.startTimer();
                this.$nextTick(() => {
                    this.shutterInterval = setTimeout(this.moveDisplayedLines, this.parameters.shutterSpeed.showTime * 1000, this.parameters.shutterSpeed.showTime);
                });
            },
            startTimer () {
                this.$nextTick(() => {
                    if (!this.timer) {
                        this.setTimer();
                    }
                });
            },
            finishGame () {
                this.soundInstance = this.$createjs.Sound.play("gameDone");
                this.soundInstance.volume = DEFAULT_VOLUME;
                this.gameFinished = true;
                this.sendStat();
                this.stopTimer();
                if (this.shutterInterval) {
                    clearInterval(this.shutterInterval);
                }
            },
            doneWithPreparing () {
                this.isGameTuned = true;
                this.gameBoxName = 'shutter__container_interactive-place_main-box';
                this.isLoading = true;
                this.registerSounds();
            },
            setFontSize (fontSize) {
                this.fontSize = fontSize;
            },
            beforeGameRestart () {
                Object.assign(this, DEFAULT_DATA());
            },
        },
        components: {
            ScalingBar,
            GamePreparationCounter,
            GameInfo,
            RotationIcon,
        },
    }
</script>

<style lang="scss" scoped>
    @import "@/assets/sass/games/playbox.scss";

    .end-game-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }

    .warning {
        display: table-cell;
        vertical-align: middle;
        text-align: center;
    }

    .shutter__container {
        display: flex;
        flex: 1 1 auto;
        overflow: hidden;
    }

    .shutter__container_body {
        display: flex;
        flex-grow: 1;
        justify-content: center;
    }

    .shutter__container_interactive-place {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: auto;
    }

    .shutter__container_interactive-place_main-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        position: relative;
        font-size: 18px;
        cursor: pointer;
        user-select: none;
        border-radius: 0px 0px 15px 15px;
        background: white;
        height: 100%;
        @include media($sm) {
            margin-bottom: 20px;
        }
        @media (orientation: landscape) {
            @include media($sm) {
                height: calc(100vh - 100px);
            }
            @include media($md) {
                height: calc(100vh - 150px);
            }
        }
        @media (orientation: portrait) {
            @include media($sm) {
                height: calc(100vh - 260px);
            }
            @include media($md) {
                height: calc(100vh - 260px);
            }
            @include media($lg) {
                height: calc(100vh - 280px);
            }
        }
    }

    .shutter__container_interactive-place_main-box_body {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 10px;
        border-radius: 5px;
        margin-top: 23px;
        transition: height 1s;
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        @include scrollbar;
        &.shutter__text {
            background: $x-color-white;
            width: 100%;
        }
    }

    .shutter__container_interactive-place_main-box_row {
        display: flex;
        text-align: center;
        position: relative;
        width: 100%;
        justify-content: center;
        .shutter__words {
            padding: 0 10px;
        }
    }

    .shutter__container_interactive-place_main-box_shutter-container {
        position: absolute;
        left: 0;
        top: 0;
        background: $hsl-color-green-48;
        height: 23px;
        width: 100%;
    }

    .shutter__container_interactive-place_header {
        font-size: 18px;
        font-weight: 500;
        text-align: start;
        align-self: center;
        text-align: center;
        @include media($sm) {
            font-size: 22px;
        }
        @include media($lg) {
            font-size: 32px;
        }
    }

    .shutter__container_buttons {
        text-align: center;
        padding: 12px 12px 12px 0;
        align-self: center;
        @include media ($xl) {
            padding: 12px;
        }
    }

    .shutter__container_interactive-place_text-label {
        font-size: 20px;
        font-weight: 500;
        margin: 10px 18px 0 23px;
        white-space: nowrap;
        text-align: center;
    }

    .shutter__container_result-container {
        padding: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .shutter__container_result-image {
        @include stack-space($space-base);
        max-width: 450px;
        max-height: 450px;
        vertical-align: middle;
    }

    .shutter__buttons-container {
        display: flex;
        justify-content: center;
        text-align: center;
        margin-top: 20px;
    }

    .shutter__link {
        @media screen and (max-width: 640px) {
            display: block;
            width: 100%;
            margin-bottom: 30px;
        }
        @include media($lg) {
            @include inline-space($space-small);
        }

        &:first-child {
            margin-right: 25px;
        }
    }

    .shutter__button {
        @media screen and (max-width: 640px) {
            width: 100%;
        }
    }

    .play-box__buttons {
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        @include media($sm) {
            margin-top: 25px;
        }
        @include media($lg) {
            flex-direction: row;
        }
    }

    .play-box__buttons--game {
        margin: 0 0 20px;
        @include media($sm) {
            margin: 0 0 25px;
        }
    }

    .play-box__button {
        margin: 20px 0;
        @include media($lg) {
            margin: 0 20px;
        }
    }

    .play-box__button:first-child {
        margin-top: 0;
        @include media($lg) {
            margin-left: 0;
        }
    }

    .play-box__button:last-child {
        margin-bottom: 0;
        @include media($lg) {
            margin-right: 0;
        }
    }

    .wave {
        position: absolute;
        bottom: 5px;
        left: 0;
        width: 100%;
        transform: rotate(180deg);
    }
    .wave::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 10px;
        background-size: 20px 40px;
        background-image: radial-gradient(circle at 10px -15px, transparent 20px, $hsl-color-green-48 21px);
    }
    .wave::after {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 15px;
        background-size: 40px 40px;
        background-image: radial-gradient(circle at 10px 26px, $hsl-color-green-48 20px, transparent 21px);
    }

    .router-link {
        margin: 5px
    }

    .fade-leave {
        top: -5px;
        opacity: 1;
    }
    .fade-leave-active {
        position: absolute;
        transition: opacity .5s, top .7s;
    }
    .fade-leave-to {
        top: -1000px;
        opacity: 0;
    }
    .fade-move {
        transition: all .7s;
    }
    .fade-move-45 {
        transition: all .45s, opacity .3s;
    }
    .fade-move-25 {
        transition: all .25s, opacity .1s;
    }
    .fade-move-1 {
        transition: all .1s, opacity 0s;
    }
    .lines-container {
        position: relative;
        width: 100%;
        padding-top: 15px;
    }
</style>
